"use strict";
// Can in theory be pulled from contentful
// https://app.contentful.com/spaces/u1nb1km7t5q7/entries/4Unp8iOHipegAdXlBLEpgh
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PAGE_TITLES = void 0;
// These are used during 5xx errors and when contentful/graphql isn't loading so having it hard coded is nice.
const DEFAULT_PAGE_TITLES = {
    'de-CH': 'Aesop Schweiz',
    'en-AU': 'Aesop Australia',
    'en-CA': 'Aesop Canada',
    'en-CH': 'Aesop Switzerland',
    'en-DE': 'Aesop',
    'en-DK': 'Aesop Denmark',
    'en-FR': 'Aesop',
    'en-GB': 'Aesop UK',
    'en-HK': 'Aesop Hong Kong SAR',
    'en-NO': 'Aesop Norway',
    'en-NZ': 'Aesop New Zealand',
    'en-SE': 'Aesop Sweden',
    'en-SG': 'Aesop Singapore',
    'es-FR': 'Aesop',
    'fr-CA': 'Aesop Canada',
    'fr-CH': 'Aesop Suisse',
    'it-IT': 'Aesop Italia',
    'ja-JP': 'Aesop 日本',
    'ko-KR': 'Aesop 대한민국',
    'zh-Hant-TW': 'Aesop 台灣地區',
    'en-US': 'Aesop United States',
    'fr-FR': 'Aesop',
    'de-DE': 'Aesop',
    'zh-Hant-HK': 'Aesop 中國香港',
};
exports.DEFAULT_PAGE_TITLES = DEFAULT_PAGE_TITLES;
//# sourceMappingURL=pageTitles.js.map